<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :updatedItems="updatedItems" :items="items"
        ><template slot="title">
          {{ $tc("changeGroup.title") }}
        </template></Header
      >
      <v-col class="mt-n5">
        <ChangeTables
          :title1="title1"
          :seeTables="false"
          :headers1="header"
          :items1="getGroupsAssigned"
        />
      </v-col>
      <v-col class="mt-n5">
        <CardDialog style="display: flex; justify-content: center">
          <template slot="title">
            <h4 style="color: #39537a; font-weight: lighter !important">
              {{ $tc("changeGroup.completeForm") }}
            </h4>
          </template>
          <template slot="body">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              class="mx-2"
              :disabled="signed"
            >
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-autocomplete
                required
                :rules="rules"
                :label="$tc('changeGroup.group')"
                dense
                outlined
                v-model="data.group"
                :items="getGroup"
                item-value="groupId"
                item-text="name"
                class="mb-1"
              />
              <date class="ml-0" />
            </v-form>
            <div class="d-flex justify-space-between mx-2 mt-10">
              <v-btn class="bt-exit" @click="cancel()" :disabled="signed"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn
                class="bt-acept"
                @click.prevent="validate"
                :disabled="signed"
              >
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </template>
        </CardDialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import CardDialog from "./common/CardDialog.vue";
import ChangeTables from "./common/ChangeTables.vue";
import Date from "./common/DateRegis.vue";
export default {
  components: { Header, CardDialog, ChangeTables, Date },
  props: {
    items: Object,
    refreshForm: Number,
  },
  data() {
    return {
      counter: 0,
      title1: this.$tc("changeGroup.groupsAssigned"),
      valid: true,
      updatedItems: [],
      alertValidate: "",
      error: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      alertError: false,
      alertOk: false,
      textAlert: "",
      data: {
        group: null,
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
      },
      fromMenuDate: false,
      toMenuDate: false,
      checkTo: this.$store.state.gestionTiempos.checkTo,
      header: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  watch: {
    refreshForm(newValue, oldValue) {
      if (newValue > oldValue) {
        this.$refs.form.resetValidation();
        this.checkTo = false;
        this.data = {
          group: null,
          from: this.$store.state.gestionTiempos.dateFromComponents,
          to: this.$store.state.gestionTiempos.dateToComponents,
          date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        };
      }
    },
  },
  computed: {
    signed() {
      return this.$store.state.gestionTiempos.signed;
    },
    getGroup() {
      return this.$store.state.changeGroup.group.item;
    },
    getGroupsAssigned() {
      return this.$store.state.changeGroup.groupAssigned.item;
    },
  },

  methods: {
    //se valida el formulario
    validate() {
      if (this.$store.state.gestionTiempos.checkTo) {
        this.$store.commit("gestionTiempos/setDateToComponents", null);
        this.data.to = null;
      }
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.from > this.data.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.addGroup();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    //se cancela el formulario
    cancel() {
      this.error = false;
      this.$emit("close");
      this.reset();
    },

    // se agrega un nuevo grupo
    addGroup() {
      let payload = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        group: this.data.group,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
      };

      this.$store.commit("changeGroup/setNew", payload);
      this.$store
        .dispatch("changeGroup/newGroup")
        .then((r) => {
          this.textAlert = this.$tc("changeGroup.alertChange");
          this.alertOk = true;

          this.counter++;

          const name = this.$store.state.changeGroup.group.item.find((item) => {
            return item.groupId === payload.group;
          }).name;

          this.updatedItems = this.updatedItems.filter(
            (item, i) => item.empId !== this.items.empId
          );

          this.updatedItems.push({
            empId: this.items.empId,
            name,
          });
          this.$store.dispatch("changeGroup/getGroupsAssigned");

          this.reset();
          setTimeout(() => {
            this.$emit("close");
          }, 2500);
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("changeSchedule.alertChangeError");
          this.reset();
        });
      this.checkTo = false;
    },
    //se resetea el formulario
    reset() {
      this.$refs.form.resetValidation();
      this.checkTo = false;
      const today = this.items.date
        .slice(0, 10)
        .split(/\D/)
        .reverse()
        .join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", today);
      this.$store.commit("gestionTiempos/setDateToComponents", today);
      this.$store.commit("gestionTiempos/setCheckTo", this.checkTo);
      this.data = {
        group: null,
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
      };
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
